<script setup>
import { ref } from 'vue';
import Modal from '@/components/Modal.vue';
import AppCard from '@/Shared/AppCard.vue';
import AppWell from '@/Shared/AppWell.vue';

const props = defineProps({
    scoreCardSummary: {
        type: Object,
        required: true,
    },
});

const show = ref(props.scoreCardSummary.shouldShow);
</script>

<template>
    <Modal :show="show" @close="show = false">
        <div>{{ $t('messages.summary') }}</div>
        <AppWell>
            <ul>
                <li v-for="item in scoreCardSummary.items" :key="item.key" class="mt-3 md:mt-5">
                    <AppCard>
                        <div class="grid grid-cols-4 gap-6 p-2">
                            <div>
                                <img :src="item.image_path" alt="" class="w-full" />
                            </div>
                            <div class="col-span-3 flex flex-col justify-between">
                                <div>
                                    {{ item.text }}
                                </div>
                                <div class="flex justify-end">
                                    <span class="text-gray-400">{{ item.time_ago }}</span>
                                </div>
                            </div>
                        </div>
                    </AppCard>
                </li>
            </ul>
        </AppWell>
    </Modal>
</template>
